export const pageVariables = {
    headers: [
        'Nome do Modelo',
        'Plano Vinculado',
        'Arquivo',
        'Versão',
        'Status',
        'Plano',
        'Ações'
    ],
   headerInfo: {
        title: "Modelos de Propostas",
        description: "Esta seção fornece informações detalhadas sobre as movimentações de segurados na fatura, registrando inclusões, alterações e cancelamentos vinculados ao período de faturamento. Acompanhe o status de cada movimentação (aberta, prévia ou fechada), as datas de referência e a empresa/apólice associada, garantindo controle, rastreabilidade e consistência antes do fechamento da fatura."
    },
    inputs: [
        { name: 'nome_modelo', label: 'Nome do Modelo', type: 'text' }
    ],
    filterFields: [
        { label: "Nome do Modelo", key: "nome_modelo", type: "text" }
    ],
    customActions: [
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" /></svg>`,
            methodName: 'baixaPreview',
            title: 'Baixar Preview Atual'
        }
    ]
};
